import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/incidencias-empleados-dia-acumulado';

/**
 * GET Incidencias Empleados Días Acumulados
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getIncidenciasEmpleadosDiasAcumulados = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Incidencia Empleado Día Acumulado
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getIncidenciaEmpleadosDiaAcumulado = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST ncidencia Empleado Día Acumulado
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postIncidenciaEmpleadosDiaAcumulado = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH ncidencia Empleado Día Acumulado
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchIncidenciaEmpleadosDiaAcumulado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE ncidencia Empleado Día Acumulado
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteIncidenciaEmpleadosDiaAcumulado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
